import { render, staticRenderFns } from "./MoreMobile.vue?vue&type=template&id=08ce8e6c&scoped=true"
import script from "./MoreMobile.vue?vue&type=script&lang=js"
export * from "./MoreMobile.vue?vue&type=script&lang=js"
import style0 from "./MoreMobile.vue?vue&type=style&index=0&id=08ce8e6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08ce8e6c",
  null
  
)

export default component.exports